<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description:
-->
<template>
  <div class="lc-steps__tree">
    <div class="lc-steps__tree-header">
      <div
        v-for="(step, index) in steps"
        :key="'step_' + index"
        :class="['lc-step', ...getStepStatus(index)]"
        :style="stepStyle(index)"
      >
        <div class="lc-step__header">
          <div class="lc-step__left">
            <div v-if="hasIndex" class="lc-step__icon">
              <span v-if="index < value" class="el-icon-check" />
              <span v-else>{{ index + 1 }}</span>
            </div>
            <div v-if="index < steps.length - 1" class="lc-step__line" />
          </div>
          <div class="lc-step__info">
            <div class="lc-step__info-title">{{ step.data.attrs.title }}</div>
            <slot :name="`desc${index + 1}`" />
          </div>
        </div>
      </div>
    </div>
    <div class="lc-steps__tree-contents">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'LcSteps',
  props: {
    hasIndex: {
      type: Boolean,
      default: true
    },
    value: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  watch: {},
  data() {
    return {};
  },
  computed: {
    getStepStatus() {
      return function (index) {
        return [this.value == index ? 'is-process' : '', index < this.value ? 'is-success' : ''];
      };
    }
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {
    changeClass(val) {
      this.$el.querySelector('.lc-steps__content-show')?.classList.remove('lc-steps__content-show');
      this.$el.querySelector(`.lc-steps__content:nth-child(${val + 1})`)?.classList.add('lc-steps__content-show');
    },
    stepStyle(index) {
      const style = {};
      style.flexBasis = 100 / this.steps.length + '%';
      if (index + 1 == this.steps.length) {
        style.flexBasis += ' !important';
      }

      return style;
    }
  }
};
</script>
